// 运营系统用户信息
export const CRM_USER = 'CRM_USER_INFO';
// 前端记录用户上次查看的知识点
export const CACHED_LO = 'Permanent_CACHED_LO_';
// 引导前缀
export const GUIDE = 'Permanent_GUIDE_';

export const CACHED_LO_AT = 'Permanent_CACHED_LO_AT';

export const CACHED_LO_MT = 'Permanent_CACHED_LO_MT';

// 共性分析班级缓存
export const CACHED_CLASS_WRONG = 'Permanent_CACHED_CLASS_WRONG';
export const CACHED_CLASS_WEAK = 'Permanent_CACHED_CLASS_WEAK';
